/* eslint-disable */
import config from '@/config';
import createjs from 'preload-js';


const debug = process.env.NODE_ENV === 'development';

const state = {
  progression: 0,
  Landing: false,
  Intro: false,
  BeforeEnter: false,
  Born: false,
  Smog: false,
  Meteo: false,
};

const mutations = {
  SET_PROGRESSION(state, value) {
    state.progression = value;
  },
  SET_COMPLETION(state, value) {
    state[value] = true;
  }
};

const actions = {
  START({commit, rootGetters, dispatch}, preloaderID) {

    commit('SET_PROGRESSION', 0);
    
    const manifest = config.getManifest(preloaderID, rootGetters['App/skipTo'], rootGetters['App/isTablet']);
    const queue = new createjs.LoadQueue();

    queue.on('progress', event => {
      commit('SET_PROGRESSION', event.progress * 100);
    });
    
    queue.on('fileload', event => {
      if (debug) console.log("--loaded-", event.item.id);
      
      switch(event.item.ext) {
        case "webm":
          dispatch('Sound/ADD', Object.assign(
            { id: event.item.id, src: event.item.src },
            config.SOUNDS[event.item.id]),
            { root: true });
          break;
            
        case "json":
          if (event.item.id.indexOf('locale') != -1) {
            commit('I18n/ADD_MESSAGES', {
              locale: event.item.id.replace("locales", "").toLowerCase(),
              messages: event.result
            }, {root:true});
          }
          else{
            commit('Textures/ADD', { spritesheet:true, file: event.item, tag: event.result }, { root: true });
          }
          break;

        default:
          if(event.item.data === 'pixi') {
            commit('Textures/ADD', {file:event.item, tag:event.result}, {root:true});
          }
          break;
      }
    });

    queue.on('complete', () => {
      dispatch('END', preloaderID);
    });

    queue.loadManifest(manifest);
  },

  END({commit, rootGetters}, id) {
    if (rootGetters['App/skipTo'] !== null) {
      commit('SET_COMPLETION', 'Landing');
      commit('SET_COMPLETION', 'Intro');
      commit('SET_COMPLETION', 'BeforeEnter');
      commit('SET_COMPLETION', 'Born');
      commit('SET_COMPLETION', 'Smog');
      commit('SET_COMPLETION', 'Meteo');
      commit('SET_COMPLETION', 'Heat');
    }
    else{
      commit('SET_COMPLETION', id);
    }
  }
};

const getters = {
  progression: state => state.progression,
  hasPreload: state => id => state[id],
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
